"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeJobsClient = void 0;
const types_1 = require("../../../types");
class FakeJobsClient {
    constructor() {
        this.jobs = [];
        this.manualJobs = [];
        this.automaticJobs = [];
    }
    insertJobFixture(job, manual = null) {
        this.jobs.push(job);
        if (manual === true) {
            this.manualJobs.push(job);
        }
        else {
            this.automaticJobs.push(job);
        }
    }
    getAll(page, filter) {
        return Promise.resolve({
            page: this.filterJobs(filter),
            pageSpec: {
                number: page.page,
                size: page.size,
                totalElements: this.jobs.length,
                totalPages: Math.floor(this.jobs.length / page.size),
                nextPage: new types_1.Link({
                    href: `/v1/jobs?size=${page.size}&page=${page.page + 1}`,
                }),
                previousPage: new types_1.Link({
                    href: `/v1/jobs?size=${page.size}&page=${page.page - 1}`,
                }),
            },
        });
    }
    filterJobs(filter) {
        if (!filter)
            return this.jobs;
        if (filter.manuallyCreated === undefined)
            return this.jobs;
        if (filter.manuallyCreated) {
            return this.manualJobs;
        }
        else if (!filter.manuallyCreated) {
            return this.automaticJobs;
        }
        else {
            throw new Error('???');
        }
    }
    clear() {
        this.jobs = [];
        this.manualJobs = [];
        this.automaticJobs = [];
    }
    get(id) {
        const retrievedJob = this.jobs.find((job) => job.id === id);
        if (retrievedJob != undefined) {
            return Promise.resolve(retrievedJob);
        }
        else {
            const boError = {
                message: `No job with id: ${id}`,
                status: 404,
                error: 'Cannot find job',
                path: `/v1/jobs/${id}`,
                timestamp: new Date(),
            };
            return Promise.reject(boError);
        }
    }
}
exports.FakeJobsClient = FakeJobsClient;
//# sourceMappingURL=FakeJobsClient.js.map